var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M53.5,62.6l893,437.4l-893,437.4l85.1-397.7l535.9-37v-5.4l-535.9-37L53.5,62.6 M53.5,19.1c-9.5,0-19,3.1-26.8,9.2C13.6,38.6,7.5,55.4,11,71.7L96,469.4c3,13.8,12.3,25,24.7,30.6c-12.4,5.6-21.7,16.7-24.7,30.6L11,928.3c-3.5,16.3,2.6,33.1,15.8,43.4c7.8,6.1,17.3,9.2,26.8,9.2c6.5,0,13.1-1.5,19.1-4.4l893-437.4c14.9-7.3,24.4-22.5,24.4-39.1c0-16.6-9.5-31.8-24.4-39.1L72.6,23.6C66.6,20.6,60,19.1,53.5,19.1L53.5,19.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/send-message.7c6c4e12004a783b43e532b86b377441.svg";
export { ForwardRef as ReactComponent };